module.exports = __webpack_public_path__ + "4b3ee00098a5bed498e62c100c4ae3ca.pdf";